import { Injectable } from '@angular/core';
import { I18nService } from 'src/app/service/i18n.service';
@Injectable({
  providedIn: 'root'
})
export class DvtagPaidPixelService {

  private loadOk: boolean = false;
  currentLang: string;
  trackingCode: string = '';
  start: string;

  constructor(private i18nService: I18nService) {
    this.currentLang = sessionStorage.getItem("lang_pref")
  }

  load(instance: String) {

    // if (!this.loadOk) {

    if (instance == "start") {
      this.trackingCode = 'DC-8205542/morpqten/appstrt+standard'
      if (this.currentLang == "fr") {
        this.trackingCode = 'DC-8205542/morpqtfr/appstrt+standard'
      }
    } else if (instance == "end") {
      this.trackingCode = 'DC-8205542/morpqten/appcomp+standard'
      if (this.currentLang == "fr") {
        this.trackingCode = 'DC-8205542/morpqtfr/appcomp+standard'
      }
    }
    const head = document.getElementsByTagName('head')[0];

    let content = "<script id=\"dvgtag\" async src=\"https://www.googletagmanager.com/gtag/js?id=DC-8205542\" type=\"text/plain\" class=\"optanon-category-C0004\"></script>"
    let content1 = "<script id=\"dvgtag_pixel\">window.dataLayer=window.dataLayer || []; function gtag(){ dataLayer.push(arguments); } gtag('js',new Date());gtag('config','DC-8205542');</script><script id=\"dc360\">gtag('event','conversion',{'allow_custom_scripts':true,'send_to':'" + this.trackingCode + "'});</script>"
    $("head").append(content);
    $("head").append(content1);


  }
}


